export const GET_MARKET_SHARE = 'GET_MARKET_SHARE'
export const GET_ALL_COMPASS = 'GET_ALL_COMPASS'
export const GET_ALL_COMPASS_TABLE = 'GET_ALL_COMPASS_TABLE'
export const GET_ALL_STATES = 'GET_ALL_STATES'
